module.exports = {
  TIME_ZONE: 'Asia/Yekaterinburg',
  DEFAULT_PERIOD: 'Без повторов',
  PERIOD_TITLES: ['Без повторов', 'Ежедневно', 'Еженедельно', 'ПН-ПТ', 'Ежемесячно', 'Ежегодно'],
  PAGINATION_ROW_COUNT: 10
};
